module.exports = __webpack_public_path__ + "media/images/title-404-38ce36c0be22214d6aee98f9f38485fb.jpg";